import React from "react";
import { Link } from "react-router-dom";

export default function Logo({ className = "", dark = false, to = "/" }) {
    return (
        <Link to={to} data-testid="logo" className={`inline-flex items-center gap-2 ${className}`}>
            <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-primary text-primary-foreground font-serif text-lg font-bold">C</span>
            <span className={`font-serif text-xl font-bold tracking-tight ${dark ? "text-primary-foreground" : "text-foreground"}`}>
                CRN Agenda <span className="font-sans font-medium text-accent">Planner</span>
            </span>
        </Link>
    );
}
